import { Divider, TextField, FormControl, Grid, Typography, useTheme, Stack, Tooltip, IconButton, FormControlLabel, Checkbox, Autocomplete, Card, CardHeader, CardContent, Alert } from "@mui/material";
import { tokens } from "../../../theme/theme";
import { useTranslation } from "react-i18next";


// Date picker components
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/material/styles';

// Utilities
import dayjs from 'dayjs';
import 'dayjs/plugin/customParseFormat';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import qrcode from 'qrcode';
import GlobalConfig from "../../../config/date/GlobalConfig";
import AddWinderProcess from "./AddNewWinderProcess";
import { useEffect, useState } from "react";
import { useParentRollNumbers } from "../../../hooks/useParentRollNumbers";
import useShiftCode from "../../../hooks/useShiftCode";
import AutoCompleteField from "../../../components/common/AutoCompleteField";
import { useOperators } from "../../../hooks/useOperators";

//icons
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import AddOperator from "../../master/AddOperator";
import InfoIcon from '@mui/icons-material/Info';

import { DATE_FORMAT } from "../../../config/date/dateConfig";
import { useParentRollDetails } from "../../../hooks/winderprocess/useParentRollDetails";
import { useCombinationDetails } from "../../../hooks/winderprocess/useCombinationDetails";
const ParentRollAndShiftDetail = ({ diffParentRollNumbers, actualSetLength, handleEdit, setLotsDetail, editLot }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();


    // 📅 Dates
    const [fromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, "day"));
    const [toDate, setToDate] = useState(dayjs());
    const [shiftDate, setShiftDate] = useState(dayjs());

    // 🔢 State
    const [selectedParentRoll, setSelectedParentRoll] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [shiftDateError, setShiftDateError] = useState("");

    const [selectedDiffParentRollNumber, setSelectedDiffParentRollNumber] = useState([]);
    const [jointParentRoll, setJointParentRoll] = useState(false);
    const [viewParentRollList, setviewParentRollList] = useState(true);
    const [viewWinderParentRollDetail, setviewWinderParentRollDetail] = useState(false);

    const [winderMONumber, setWinderMONumber] = useState(0);
    const [winderMANumber, setWinderMANumber] = useState(0);
    const [setWeight, setSetWeight] = useState(0);
    const [selectedCore, setSelectedCore] = useState(0);
    const [setDiameter, setSetDiameter] = useState(0);
    const [sharedLength, setSharedLength] = useState(0);
    const [sharedQty, setSharedQty] = useState(0);
    const [totalJoints, setTotalJoints] = useState(0);
    const [noLength, setNoLength] = useState(false);


    // 🔌 Hooks
    const { parentRollNumbers, parentRollLoading, parentRollError } = useParentRollNumbers(fromDate, toDate);
    const { shiftCode, selectedShiftCode, selectedShiftCodeID, setSelectedShiftCode, setSelectedShiftCodeID, loadShiftCodeByID, } = useShiftCode(0);
    const { operators, selectedOperator, setSelectedOperator, loading, error, refreshOperator } = useOperators(false);
    const { parentRollDetails, lotsDetail, parentRollDate, parentRollDetailLoading, parentRollDetailError, loadSelectedLotDetails, } = useParentRollDetails(winderMONumber, winderMANumber);

    const { selectedCombination, availableLot, selectedSetID, combinationStatus, isExtraSetModalOpen, loadingAvailableSets, errorAvailableSets, getParticularCombinationDetails, } = useCombinationDetails(actualSetLength);



    // card design 
    const DetailRow = ({ label, value }) => (
        <Grid container item xs={12}>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="left">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="right" fontWeight="bold">
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );


    // 🎯 Handlers
    const handleShiftChange = (_, value) => {
        if (value) {
            setSelectedShiftCode(value);
            setSelectedShiftCodeID(value.shiftid);
        }
    };

    const handleOperatorChange = (_, value) => {
        setSelectedOperator(value);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        refreshOperator();
    };

    const handleUseLoosePallete = (event) => {
    };

    const handleSelectDifferendParentRollNumber = (event, value) => {
    };


    const handleUpdateParentRoll = (roll) => {
        console.log("Updated roll:", roll);

    };

    const handleToggleViews = (views) => {
        setviewWinderParentRollDetail(views.viewWinderParentRollDetail);
        // setviewWinderParentRollPlanningDetail(views.viewWinderParentRollPlanningDetail);
        // setviewWinderParentRollSummaryDetail(views.viewWinderParentRollSummaryDetail);
    };

    const handleLotDetail = (lotDetail) => {
        setLotsDetail(lotDetail);
    }


    const handleEditLot = (row) => {
        handleEdit(row);
    };

    const handleParentRollSection = (parentRollNumber) => {
        loadSelectedLotDetails(parentRollNumber, "new", {
            updateParentRollDetails: handleUpdateParentRoll,
            handleEdit: handleEditLot,
            toggleViews: handleToggleViews,
            lotList: handleLotDetail,
        });
    };


    const loadMADetails = () => {

    };

  

    // helper to fetch when editLot changes
    const handleEditLotDetail = async (row) => {
        if (!row) return;

        setWinderMONumber(row.release_no);
        setWinderMANumber(row.lot_no);
        await getParticularCombinationDetails(
            row.release_no,
            row.lot_no,
            row.reel_length,
            row.reel_length,
            () => loadMADetails && loadMADetails()
        );
    };

    // trigger when editLot changes
    useEffect(() => {
        if (editLot && Object.keys(editLot).length > 0) {
            handleEditLotDetail(editLot);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editLot]); // ✅ runs only when editLot changes


    return (
        <>

            <Grid container>
                <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                    <Grid container spacing={0}  >

                        {/* parent roll and shift detail */}
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={5}   >

                            <Grid container padding="5px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" > {t('prod_winder_machine.filter_by')} </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                    <FormControl fullWidth size="small">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                style={{ marginLeft: '10px' }}
                                                id="FromDate"
                                                value={dayjs(fromDate)}
                                                onChange={setFromDate}
                                                slotProps={{ textField: { size: 'small', } }}
                                                // renderInput={(props) => <TextField {...props} />}
                                                autoFocus
                                                format={DATE_FORMAT}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                    <FormControl fullWidth size="small" >
                                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                            <DatePicker
                                                id="ToDate"
                                                value={dayjs(toDate)}
                                                format={DATE_FORMAT}
                                                onChange={setToDate}
                                                slotProps={{ textField: { size: "small" } }}
                                            // renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        {t('prod_winder_machine.parent_roll_number')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={7.8} xl={6.2}>
                                    <AutoCompleteField
                                        label="Parent Roll"
                                        placeholder="Select Parent Roll"
                                        options={parentRollNumbers}
                                        value={selectedParentRoll}
                                        onChange={(_, v) => { setSelectedParentRoll(v); handleParentRollSection(v.pr_number); }}
                                        loading={parentRollLoading}
                                        getOptionLabel={(o) => o.pr_number}
                                    />
                                </Grid>

                            </Grid>

                            {/* shift code and time  */}

                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        {t('prod_winder_machine.shift_date_time')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                    <FormControl fullWidth size="small">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Stack spacing={1}>
                                                <DatePicker
                                                    value={shiftDate}
                                                    onChange={setShiftDate}
                                                    format="DD-MMM-YYYY"
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            error: !!shiftDateError,
                                                            helperText: shiftDateError,
                                                        },
                                                    }}
                                                />
                                            </Stack>
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                    <FormControl fullWidth size="small">
                                        <AutoCompleteField
                                            label="Shift Code"
                                            placeholder="Select Shift Code"
                                            options={shiftCode}
                                            value={selectedShiftCode}
                                            onChange={handleShiftChange}
                                            getOptionLabel={(o) => o.shiftcode}
                                        />
                                    </FormControl>
                                </Grid>

                            </Grid>

                            {/* operator */}
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        {t('prod_winder_machine.winder_operator')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={5.6}>
                                    <FormControl fullWidth size="small">
                                        <AutoCompleteField
                                            label="Operator"
                                            placeholder="Select Operator"
                                            options={operators}
                                            value={selectedOperator}
                                            onChange={handleOperatorChange}
                                            loading={false}
                                            getOptionLabel={(o) => o.operator_code}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                    <Tooltip title="Add new operator" arrow>
                                        <IconButton size="small" color="secondary" onClick={() => setIsModalOpen(true)}>
                                            <AddCircleIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>

                            </Grid>

                            {selectedCombination?.length > 0 && (
                                <div>

                                    <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        {actualSetLength != 0 && (
                                            <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
                                                <FormControlLabel
                                                    control={<Checkbox size="small" color="secondary" checked={jointParentRoll} onChange={handleUseLoosePallete} />}
                                                    label={<Typography variant="h6" fontSize={14}>
                                                        {t('prod_winder_machine.joint')}
                                                    </Typography>
                                                    } >
                                                </FormControlLabel>
                                            </Grid>
                                        )}
                                    </Grid>

                                    <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        {jointParentRoll && Array.isArray(diffParentRollNumbers) && (
                                            <>
                                                <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                        {t('prod_winder_machine.select_differend_parent_roll')}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={11} md={8} lg={7.6} xl={6.2}>
                                                    <Autocomplete
                                                        autoFocus
                                                        variant="standard"
                                                        multiple
                                                        value={selectedDiffParentRollNumber || []}
                                                        onChange={handleSelectDifferendParentRollNumber}
                                                        fontSize="8px"
                                                        size="small"
                                                        disabled={viewParentRollList}
                                                        options={diffParentRollNumbers || []}
                                                        getOptionLabel={(option) => `${option?.pr_number || ''}`}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                    />
                                                </Grid>
                                            </>)}
                                    </Grid>
                                </div>
                            )}
                        </Grid>

                        {/* selected ma detail */}
                        <Grid item xs={12} sm={12} md={6} lg={5.8} xl={4}>
                            {viewWinderParentRollDetail && (
                                <>
                                    {selectedCombination?.[0]?.combinations && (
                                        <>
                                            <Card sx={{ borderRadius: "12px", boxShadow: 3, marginLeft: "auto" }} >
                                                <CardHeader
                                                    title="Selected Parent Roll MO & MA Details"
                                                    avatar={<InfoIcon color="secondary" />}
                                                    sx={{ backgroundColor: colors.primary[400], padding: "8px" }}
                                                />

                                                <CardContent sx={{ padding: "12px" }}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>Selected MO #</Typography>
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Typography variant="body2">{winderMONumber}</Typography>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>MA #</Typography>
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Typography variant="body2">{winderMANumber}</Typography>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>Combination</Typography>
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Typography variant="body2">{selectedCombination?.[0]?.combinations ?? '—'}</Typography>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>Total Sets</Typography>
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Typography variant="body2">{selectedCombination?.[0]?.sets ?? 0}</Typography>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>Produced Sets</Typography>
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Typography variant="body2">{selectedCombination?.[0]?.p_set ?? 0}</Typography>
                                                        </Grid>
                                                    </Grid>

                                                    {actualSetLength !== 0 && setWeight && (
                                                        <>
                                                            <Divider sx={{ my: 1.5 }} />
                                                            <Grid container spacing={1}>

                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Total Set Weight</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{setWeight || 0} </Typography>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Core ID / Diameter</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{`${selectedCore || 0}/${setDiameter || 0}`} </Typography>
                                                                </Grid>
                                                                {sharedLength > 0 && (
                                                                    <>
                                                                        <DetailRow label="Joined Length" value={sharedLength || 0} />
                                                                        <DetailRow label="Joined Length Weight" value={sharedQty || 0} />
                                                                        <DetailRow label="Total Joints in Child Reel" value={totalJoints || 0} />
                                                                    </>
                                                                )}
                                                            </Grid>
                                                        </>
                                                    ) || (null)}

                                                    {noLength && (
                                                        <Alert severity="warning" sx={{ mt: 1.5 }}>
                                                            No balance length is available for this MA number.
                                                        </Alert>
                                                    )}
                                                </CardContent>

                                            </Card>
                                        </>
                                    ) || null}
                                </>
                            ) || null}
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

            {/* Render modal if isModalOpen is true */}
            {
                isModalOpen && <AddOperator onClose={handleCloseModal} open={isModalOpen} />
            }
        </>
    )
}
export default ParentRollAndShiftDetail;


